module.exports = __webpack_public_path__ + "static/media/400008_01.dc90801c.png";